export const DEFAULT_QUERY_CACHE_STALE_TIME = 5 * 60 * 100; // 5 minutes of caching

export const TOP_NAV_BAR_HEIGHT = 50;
